import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EmployerContactSubmissionChange } from './employer-contact-submission-change';
import { EmployerContactSubmissionChangeTypeEnum } from './employer-contact-submission-change-type.enum';

@Component({
  selector: 'app-employer-update-contact-submission-contact-changes',
  templateUrl: './employer-update-contact-submission-contact-changes.component.html',
  styleUrls: ['./employer-update-contact-submission-contact-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EmployerUpdateContactSubmissionContactChangesComponent implements OnChanges {
  @Input() previousChanges: EmployerContactSubmissionChange[] = [];
  @Input() newChanges: EmployerContactSubmissionChange[] = [];

  public hasChanges = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.previousChanges && changes.newChanges) {
      this.hasChanges = [...this.previousChanges, ...this.newChanges].some(
        change => change.changeType !== EmployerContactSubmissionChangeTypeEnum.Unchanged
      );
    }
  }

  public trackByFn(index: number): number {
    return index;
  }

  protected readonly EmployerContactSubmissionChangeTypeEnum = EmployerContactSubmissionChangeTypeEnum;
}
